import { TableCell, TableRow, Tooltip } from '@mui/material';
import React from 'react';

export default function LogsTableContent({
  row,
  columns,
  index,
}) {
  const formatDateTime = (dateString) => {
    const options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      timeZoneName: 'short',
    };
    return new Date(dateString).toLocaleString(undefined, options);
  };

  const getColumnContent = (column) => {
    const { id: columnId } = column;

    if (columnId === 'sno') {
      return index + 1;
    } else if (columnId === 'created_at') {
      return  formatDateTime(row[columnId])
    } else if (columnId === 'data') {
      const data = row[columnId] || 'NA';
      return (
        <Tooltip title={data} >
          <div
            style={{
              overflow: 'hidden',
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 2,
              textOverflow: 'ellipsis',
              maxWidth: '200px',
              margin: '0 auto',
            }}>
            {data}
          </div>
        </Tooltip>
      );
    } else {
      return row[columnId] || 'NA';
    }
  };

  return (
    <TableRow hover key={row.id}>
      {columns.map((column, columnIndex) => (
        <TableCell
          key={column.id}
          align="center"
          sx={
            columns.length === columnIndex
              ? {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: column.id === 'pictures' ? '80px' : 'auto',
                }
              : {}
          }>
          {getColumnContent(column)}
        </TableCell>
      ))}
    </TableRow>
  );
}
